// Imports
var ___CSS_LOADER_API_SOURCEMAP_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/sourceMaps.js");
var ___CSS_LOADER_API_IMPORT___ = require("../../../../node_modules/@angular-devkit/build-angular/node_modules/css-loader/dist/runtime/api.js");
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.adf-media-player {
  display: flex;
}
.adf-media-player video {
  display: flex;
  flex: 1;
  max-height: 70%;
  max-width: 100%;
  margin-top: 80px;
}

.sidenav-container {
  height: calc(100vh - 64px);
}

.mat-sidenav1 {
  padding: 20px 20px;
  background: white;
}

.mat-sidenav-content {
  padding: 10px 0;
  padding-top: 0;
  background: white;
}

.color-icon {
  color: #029de6;
}`, "",{"version":3,"sources":["webpack://./src/app/viewer/components/mediaPlayer.component.scss"],"names":[],"mappings":"AAAA;EACE,aAAA;AACF;AACE;EACE,aAAA;EACA,OAAA;EACA,eAAA;EACA,eAAA;EACA,gBAAA;AACJ;;AAEA;EACE,0BAAA;AACF;;AAEA;EACE,kBAAA;EACA,iBAAA;AACF;;AAEA;EACE,eAAA;EACA,cAAA;EACA,iBAAA;AACF;;AACA;EACE,cAAA;AAEF","sourcesContent":[".adf-media-player {\r\n  display: flex;\r\n\r\n  video {\r\n    display: flex;\r\n    flex: 1;\r\n    max-height: 70%;\r\n    max-width: 100%;\r\n    margin-top: 80px;\r\n  }\r\n}\r\n.sidenav-container {\r\n  height: calc(100vh - 64px);\r\n}\r\n\r\n.mat-sidenav1 {\r\n  padding: 20px 20px;\r\n  background: white;\r\n}\r\n\r\n.mat-sidenav-content {\r\n  padding: 10px 0;\r\n  padding-top: 0;\r\n  background: white;\r\n}\r\n.color-icon {\r\n  color: #029de6;\r\n}\r\n"],"sourceRoot":""}]);
// Exports
module.exports = ___CSS_LOADER_EXPORT___.toString();
